import { render, staticRenderFns } from "./SupplierOrder.vue?vue&type=template&id=b11afc6c&lang=pug&"
import script from "./SupplierOrder.vue?vue&type=script&lang=ts&"
export * from "./SupplierOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports